module.exports = __webpack_public_path__ + "static/img/connect.79153ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/connect.png
// module id = t3rT
// module chunks = 1